import { AprAndDjSourcerSection } from "./apr/AprAndDjSourcerSection";
import { DifficultyUrgencySection } from "./DifficultyUrgencySection";
import { GeneralSection } from "./GeneralSection";
import { JobAdminSection } from "./JobAdminSection";
import { SetupCompletionTracker } from "./SetupCompletionTracker";
import { SourcingConfigurationSection } from "./SourcingConfigurationSection";
import { VoiceAiSection } from "./VoiceAiSection";
import { Column, ErrorPlaceholder } from "@/components";

import { useGetCurrentUser } from "@/hooks/queries/useGetCurrentUser";
import { MATT_ID, MICHAEL_ID } from "@/lib/constants";
import { cn } from "@/lib/utils";
import { JobInternalConfig as JobInternalConfigType } from "@/types";

export const JobInternalConfig = ({
  className,
  jobInternalConfig,
}: {
  className?: string;
  jobInternalConfig?: JobInternalConfigType;
}) => {
  /* Local Storage */
  const currentUserId = useGetCurrentUser()?.id;

  /* Helpers */
  // Matt and Moo are authorized to access the job admin section.
  const isAuthorizedUser =
    currentUserId === MICHAEL_ID || currentUserId === MATT_ID;

  /* Render */
  const render = () => {
    if (!jobInternalConfig) {
      return <ErrorPlaceholder errorMessage="Job Internal Config not found" />;
    }

    return (
      <div className="min-h-screen bg-slate-50">
        <Column
          className={cn("mx-auto w-full max-w-3xl gap-6 py-6", className)}
        >
          <SetupCompletionTracker jobInternalConfig={jobInternalConfig} />
          <GeneralSection jobInternalConfig={jobInternalConfig} />
          <DifficultyUrgencySection />
          <VoiceAiSection jobInternalConfig={jobInternalConfig} />
          <AprAndDjSourcerSection jobInternalConfig={jobInternalConfig} />
          <SourcingConfigurationSection />
          {isAuthorizedUser && (
            <JobAdminSection />
          )}
        </Column>
      </div>
    );
  };

  return render();
};
